import IconLoader from "@/features/Common/components/IconLoader";
import WellnessCategoryCard from "../WellnessCategoryCard";
import { useTranslation } from "react-i18next";
import { WellnessCategoryCardProps } from "../Common/types";

export default function YourInfoCard() {
  const { t } = useTranslation();

  const yourInfoProps: WellnessCategoryCardProps = {
    icon: (
      <IconLoader icon="YourInfoIcon" color="primary" sx={{ fontSize: 40 }} />
    ),
    title: "Your Info",
    description: t("YourInfo.description"),
  };

  return <WellnessCategoryCard {...yourInfoProps}></WellnessCategoryCard>;
}
